import countries from '@/resources/countryUtils.json';

export const addHreflang = () => {
    countries.forEach((country) => {
        const linkHreflang = document.createElement('link');
        linkHreflang.setAttribute('href', `https://${country.site_url}`);
        linkHreflang.setAttribute('hreflang', country.locale);
        linkHreflang.setAttribute('rel', 'alternate');
        document.head.appendChild(linkHreflang);
    });
};
